import clsx from 'clsx'

// Mirrors ResultUpsellCard's layout so the loading state holds the same height.
export function SkeletonUpsellCard({ className }) {
  return (
    <div className={clsx('flex w-full items-stretch bg-primary-white', className)}>
      <div className="aspect-1 h-full w-[100px] shrink-0 animate-pulse bg-neutrals-light-grey md:w-[120px]"></div>
      <div className="flex min-w-0 grow flex-col justify-between gap-y-3 px-3 py-2">
        <div className="flex min-w-0 flex-col gap-y-1.5">
          <div className="h-[18px] w-3/4 animate-pulse bg-neutrals-light-grey"></div>
          <div className="h-[18px] w-[60px] animate-pulse bg-neutrals-light-grey"></div>
        </div>
        <div className="h-9 w-full animate-pulse bg-neutrals-light-grey"></div>
      </div>
    </div>
  )
}
